import { useViewportSize } from '@calendly/ui/hooks/viewport-size-context'

import { getDefaultEventTypeEditorCrudTab, getEventTypeEditorCrudTab } from './tabs/registry'

export const EDITOR_TIER = {
  small: 'small',
  medium: 'medium',
  large: 'large'
}

export const EDITOR_MODE = {
  menu: 'menu',
  detail: 'detail'
}

// Derives { tier, mode, activeTab, showBackToMenu } from route :tab + device tier.
export const useEditorLayout = ({ tabKey }) => {
  const { isSmallViewport, isLargeViewport } = useViewportSize()

  const getTier = () => {
    if (isSmallViewport) return EDITOR_TIER.small
    if (isLargeViewport) return EDITOR_TIER.large
    return EDITOR_TIER.medium
  }
  const tier = getTier()

  const resolvedTab = getEventTypeEditorCrudTab(tabKey)
  const activeTab = resolvedTab || getDefaultEventTypeEditorCrudTab()

  const mode = tier === EDITOR_TIER.small && !resolvedTab
    ? EDITOR_MODE.menu
    : EDITOR_MODE.detail

  const showBackToMenu = tier === EDITOR_TIER.small && mode === EDITOR_MODE.detail

  return {
    tier,
    mode,
    activeTab,
    showBackToMenu
  }
}
